// "use client";

// import { useEffect, useState } from "react";
// import axios from "axios";
// import { TimePicker } from "antd";
// import { Checkbox } from "src/components/ui/checkbox";
// import { Trash2, Edit, Plus, Save, X, Loader2 } from "lucide-react";
// import dayjs from "dayjs";
// import { Card } from "../../../../components/ui/card";
// import { Button } from "../../../../components/ui/button";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "../../../../components/ui/select";
// import { formatTime } from "../../../../lib/utils";
// import { BaseUrlApi } from "../../../../lib/api";

// export default function TeacherScheduler() {
//   // State for availabilities and form
//   const [availabilities, setAvailabilities] = useState([]);
//   const [fetchLoading, setFetchLoading] = useState(true);
//   const [addLoading, setAddLoading] = useState(false);
//   const [updateLoading, setUpdateLoading] = useState(false);
//   const [deleteLoadingIds, setDeleteLoadingIds] = useState([]);
//   const [error, setError] = useState("");
//   const [editingId, setEditingId] = useState(null);

//   // Form state
//   const [formData, setFormData] = useState({
//     day_of_week: "Monday",
//     start_time: "09:00",
//     end_time: "11:00",
//     is_recurring: true,
//   });

//   // Days of week
//   const daysOfWeek = [
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//     "Saturday",
//     "Sunday",
//   ];

//   // Time slots for the header (from 8:00 to 18:00)
//   const timeSlots = Array.from({ length: 31 }, (_, i) => {
//     const hour = Math.floor(i / 2) + 8;
//     const minute = i % 2 === 0 ? "00" : "30";
//     return `${hour}:${minute}`;
//   });

//   // Fetch availabilities
//   const fetchAvailabilities = async () => {
//     try {
//       const { data } = await axios.get(`${BaseUrlApi}/teacher_availability`);
//       setAvailabilities(data.data);
//       setError("");
//     } catch (err) {
//       setError("Failed to fetch availabilities");
//       console.error(err);
//     } finally {
//       setFetchLoading(false);
//     }
//   };

//   // Add new availability
//   const addAvailability = async () => {
//     try {
//       setAddLoading(true);
//       const response = await axios.post(
//         `${BaseUrlApi}/teacher_availability`,
//         formData
//       );
//       setAvailabilities([...availabilities, response.data]);
//       // Reset form
//       setFormData({
//         day_of_week: "Monday",
//         start_time: "09:00",
//         end_time: "11:00",
//         is_recurring: true,
//       });
//       setError("");
//       await fetchAvailabilities();
//     } catch (err) {
//       setError("Failed to add availability");
//       console.error(err);
//     } finally {
//       setAddLoading(false);
//     }
//   };

//   // Update availability
//   const updateAvailability = async () => {
//     if (!editingId) return;

//     try {
//       setUpdateLoading(true);
//       await axios.put(
//         `${BaseUrlApi}/teacher_availability/${editingId}`,
//         formData
//       );

//       // Update local state (you may also choose to re-fetch availabilities)
//       setAvailabilities(
//         availabilities.map((item) =>
//           item.id === editingId ? { ...formData, id: editingId } : item
//         )
//       );

//       // Reset editing state
//       setEditingId(null);
//       setFormData({
//         day_of_week: "Monday",
//         start_time: "09:00",
//         end_time: "11:00",
//         is_recurring: true,
//       });
//       setError("");
//       await fetchAvailabilities();
//     } catch (err) {
//       setError("Failed to update availability");
//       console.error(err);
//     } finally {
//       setUpdateLoading(false);
//     }
//   };

//   // Delete availability
//   const deleteAvailability = async (id) => {
//     try {
//       setDeleteLoadingIds((prev) => [...prev, id]);
//       await axios.delete(`${BaseUrlApi}/teacher_availability/${id}`);
//       setAvailabilities(availabilities.filter((item) => item.id !== id));
//       setError("");
//       await fetchAvailabilities();
//     } catch (err) {
//       setError("Failed to delete availability");
//       console.error(err);
//     } finally {
//       setDeleteLoadingIds((prev) => prev.filter((itemId) => itemId !== id));
//     }
//   };

//   // Start editing an availability
//   const startEditing = (availability) => {
//     setEditingId(availability.id || null);
//     setFormData({
//       day_of_week: availability.day_of_week,
//       start_time: formatTime(dayjs(availability.start_time, "HH:mm")),
//       end_time: formatTime(dayjs(availability.end_time, "HH:mm")),
//       is_recurring: availability.is_recurring === 1 ? true : false,
//     });
//   };

//   // Cancel editing
//   const cancelEditing = () => {
//     setEditingId(null);
//     setFormData({
//       day_of_week: "Monday",
//       start_time: "09:00",
//       end_time: "11:00",
//       is_recurring: true,
//     });
//   };

//   // Handle form changes
//   const handleChange = (field, value) => {
//     setFormData({ ...formData, [field]: value });
//   };

//   // Calculate position and width for availability blocks
//   const getBlockStyle = (start, end) => {
//     // Convert time strings to minutes since 8:00
//     const startMinutes = getMinutesSince8AM(start);
//     const endMinutes = getMinutesSince8AM(end);

//     // Calculate position and width as percentages
//     const totalMinutes = 10 * 60; // 10 hours (8:00 - 18:00)
//     const left = (startMinutes / totalMinutes) * 100;
//     const width = ((endMinutes - startMinutes) / totalMinutes) * 100;

//     return {
//       left: `${left}%`,
//       width: `${width}%`,
//     };
//   };

//   // Helper to convert time string to minutes since 8:00 AM
//   const getMinutesSince8AM = (timeStr) => {
//     const [hours, minutes] = timeStr.split(":").map(Number);
//     return (hours - 8) * 60 + minutes;
//   };

//   // Load data on component mount
//   useEffect(() => {
//     setFetchLoading(true);
//     fetchAvailabilities();
//   }, []);

//   return (
//     <div className="container mx-auto p-4">
//       <h1 className="text-2xl font-bold mb-6">
//         Teacher Availability Scheduler
//       </h1>

//       {error && (
//         <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
//           {error}
//         </div>
//       )}

//       {/* Global Loading indicator for fetch */}
//       {fetchLoading && (
//         <div className="mb-4 text-blue-600 font-medium">
//           Loading availabilities...
//         </div>
//       )}

//       {/* Add/Edit Form */}
//       <Card className="mb-8 p-4">
//         <h2 className="text-xl font-semibold mb-4">
//           {editingId ? "Edit Availability" : "Add New Availability"}
//         </h2>
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//           <div>
//             <label htmlFor="day">Day of Week</label>
//             <Select
//               value={formData.day_of_week}
//               onValueChange={(value) => handleChange("day_of_week", value)}
//               className="w-full p-2 border rounded"
//               disabled={addLoading || updateLoading}
//             >
//               <SelectTrigger className="rounded-lg" aria-label="Select a day">
//                 <SelectValue placeholder="Select a day" />
//               </SelectTrigger>
//               <SelectContent>
//                 {daysOfWeek.map((day) => (
//                   <SelectItem key={day} value={day}>
//                     {day}
//                   </SelectItem>
//                 ))}
//               </SelectContent>
//             </Select>
//           </div>

//           <div>
//             <label htmlFor="start_time">Start Time</label>
//             <TimePicker
//               format="HH:mm"
//               value={dayjs(formData.start_time, "HH:mm")}
//               onChange={(time) =>
//                 handleChange(
//                   "start_time",
//                   time ? time.format("HH:mm") : "09:00"
//                 )
//               }
//               className="w-full"
//               disabled={addLoading || updateLoading}
//             />
//           </div>

//           <div>
//             <label htmlFor="end_time">End Time</label>
//             <TimePicker
//               format="HH:mm"
//               value={dayjs(formData.end_time, "HH:mm")}
//               onChange={(time) =>
//                 handleChange("end_time", time ? time.format("HH:mm") : "11:00")
//               }
//               className="w-full"
//               disabled={addLoading || updateLoading}
//             />
//           </div>

//           <div className="flex items-center">
//             <Checkbox
//               id="recurring"
//               checked={formData.is_recurring}
//               onCheckedChange={(checked) =>
//                 handleChange("is_recurring", !!checked)
//               }
//               disabled={addLoading || updateLoading}
//             />
//             <label htmlFor="recurring" className="ml-2">
//               Recurring
//             </label>
//           </div>
//         </div>

//         <div className="mt-4 flex gap-2">
//           {editingId ? (
//             <>
//               <Button
//                 onClick={updateAvailability}
//                 className="bg-green-600 hover:bg-green-700 text-white"
//                 disabled={updateLoading}
//               >
//                 {updateLoading ? (
//                   <>
//                     <Loader2 className="animate-spin" />
//                   </>
//                 ) : (
//                   <>
//                     <Save className="w-4 h-4 mr-2" /> Save Changes
//                   </>
//                 )}
//               </Button>
//               <Button
//                 onClick={cancelEditing}
//                 variant="outline"
//                 disabled={updateLoading}
//               >
//                 <X className="w-4 h-4 mr-2" /> Cancel
//               </Button>
//             </>
//           ) : (
//             <Button
//               onClick={addAvailability}
//               className="bg-blue-600 hover:bg-blue-700 text-white"
//               disabled={addLoading}
//             >
//               {addLoading ? (
//                 <Loader2 className="animate-spin" />
//               ) : (
//                 <>
//                   <Plus className="w-4 h-4 mr-2" /> Add Availability
//                 </>
//               )}
//             </Button>
//           )}
//         </div>
//       </Card>

//       {/* Schedule View */}
//       <div className="overflow-x-auto">
//         <div className="w-full">
//           {/* Time header */}
//           {/* <div className="flex border-b">
//             <div className="w-24 shrink-0"></div>
//             <div className="flex-1 relative">
//               {timeSlots.map((time, index) => (
//                 <div
//                   key={time}
//                   className="absolute text-xs font-medium"
//                   style={{
//                     left: `${(index / (timeSlots.length - 1)) * 100}%`,
//                     transform: "translateX(-50%)",
//                   }}
//                 >
//                   {time}
//                 </div>
//               ))}
//             </div>
//           </div> */}

//           {/* Day rows with availability blocks */}
//           {daysOfWeek.map((day) => (
//             <div key={day} className="flex border-b py-4 items-center">
//               <div className="w-24 shrink-0 font-medium">{day}</div>
//               <div className="flex-1 relative h-12">
//                 {/* Time grid lines */}
//                 {timeSlots.map((time, index) => (
//                   <div
//                     key={time}
//                     className="absolute h-full border-l border-muted-foreground/10"
//                     style={{
//                       left: `${(index / (timeSlots.length - 1)) * 100}%`,
//                     }}
//                   ></div>
//                 ))}

//                 {/* Availability blocks */}
//                 {availabilities
//                   .filter((a) => a.day_of_week === day)
//                   .map((availability, index) => {
//                     const style = getBlockStyle(
//                       availability.start_time,
//                       availability.end_time
//                     );
//                     const isDeleting = deleteLoadingIds.includes(
//                       availability.id
//                     );
//                     return (
//                       <div
//                         key={availability.id || index}
//                         className="absolute h-8 top-2 rounded bg-blue-500 text-white text-xs flex items-center justify-between px-2"
//                         style={style}
//                       >
//                         <span className="truncate">
//                           {availability.start_time} - {availability.end_time}
//                         </span>
//                         <div className="flex gap-1">
//                           <button
//                             onClick={() => startEditing(availability)}
//                             className="p-1 hover:bg-blue-600 rounded"
//                             disabled={isDeleting}
//                           >
//                             <Edit className="w-3 h-3" />
//                           </button>
//                           <button
//                             onClick={() =>
//                               availability.id &&
//                               deleteAvailability(availability.id)
//                             }
//                             className="p-1 hover:bg-blue-600 rounded"
//                             disabled={isDeleting}
//                           >
//                             {isDeleting ? (
//                               <Loader2 className="animate-spin size-3" />
//                             ) : (
//                               <Trash2 className="w-3 h-3" />
//                             )}
//                           </button>
//                         </div>
//                       </div>
//                     );
//                   })}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* List View */}
//       <div className="mt-8">
//         <h2 className="text-xl font-semibold mb-4">All Availabilities</h2>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//           {availabilities.map((availability) => {
//             const isDeleting = deleteLoadingIds.includes(availability.id);
//             return (
//               <Card key={availability.id} className="p-4">
//                 <div className="flex justify-between items-start">
//                   <div>
//                     <h3 className="font-medium">{availability.day_of_week}</h3>
//                     <p>
//                       {availability.start_time} - {availability.end_time}
//                     </p>
//                     <p className="text-sm text-gray-500">
//                       {availability.is_recurring ? "Recurring" : "One-time"}
//                     </p>
//                   </div>
//                   <div className="flex gap-2">
//                     <button
//                       onClick={() => startEditing(availability)}
//                       className="p-1 hover:bg-gray-100 rounded"
//                       disabled={isDeleting}
//                     >
//                       <Edit className="w-4 h-4" />
//                     </button>
//                     <button
//                       onClick={() =>
//                         availability.id && deleteAvailability(availability.id)
//                       }
//                       className="p-1 hover:bg-gray-100 rounded text-red-500"
//                       disabled={isDeleting}
//                     >
//                       {isDeleting ? (
//                         <Loader2 className="animate-spin" />
//                       ) : (
//                         <Trash2 className="w-4 h-4" />
//                       )}
//                     </button>
//                   </div>
//                 </div>
//               </Card>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }

// ---------------------------------------------------------------

import { useState, useEffect } from "react";
import axios from "axios";
import {
  format,
  addDays,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  isSameDay,
  parseISO,
  differenceInDays,
} from "date-fns";
import {
  Loader2,
  Plus,
  ChevronLeft,
  ChevronRight,
  Calendar,
  Trash,
} from "lucide-react";
import { DatePicker, TimePicker } from "antd";
import dayjs from "dayjs";

import { Button } from "src/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/components/ui/dialog";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "src/components/ui/alert-dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/components/ui/select";
import { toast } from "sonner";
import { BaseUrlApi, ErrorMessage } from "../../../../lib/api";
import TimeSelectorTeacher from "../../../../components/common/TimeSelectorTeacher";

const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const shortDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const hours = Array.from({ length: 24 }, (_, index) => index);

const dayNameToIndex = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export default function TeacherSchedulePage() {
  const [currentWeek, setCurrentWeek] = useState(new Date());
  const [availabilities, setAvailabilities] = useState([]);
  const [loading, setLoading] = useState({
    availabilities: true,
    edit: false,
    delete: false,
  });
  const [errors, setErrors] = useState({});
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [availabilityToDelete, setAvailabilityToDelete] = useState(null);

  // Form state with HH:mm format for start_time and end_time
  const [form, setForm] = useState({
    day_of_week: "Monday",
    start_time: "09:00",
    end_time: "11:00",
    start_date: "",
    end_date: "",
  });

  // Calculate week boundaries and days for the grid
  const weekStart = startOfWeek(currentWeek, { weekStartsOn: 0 });
  const weekEnd = endOfWeek(currentWeek, { weekStartsOn: 0 });
  const daysInWeek = eachDayOfInterval({ start: weekStart, end: weekEnd });

  // Fetch teacher availabilities on component mount

  // Function to fetch teacher availabilities
  const fetchAvailabilities = async () => {
    try {
      // In a real application, this would be an API call
      const { data } = await axios.get(`${BaseUrlApi}/teacher_availability`);
      setAvailabilities(data.data || []);
    } catch (error) {
      const errorMessage = ErrorMessage(error);
      toast("Error", {
        description:
          typeof errorMessage === "string"
            ? errorMessage
            : "Failed to fetch availabilities",
      });
    } finally {
      setLoading({ availabilities: false });
    }
  };

  useEffect(() => {
    fetchAvailabilities();
  }, []);

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (
      !form.day_of_week ||
      !form.start_time ||
      !form.end_time ||
      !form.start_date ||
      !form.end_date
    ) {
      toast("Error", {
        description: "Please fill in all fields",
      });
      return;
    }

    try {
      setLoading({ edit: true });
      setErrors({});

      if (isEditing && currentId) {
        await axios.put(
          `${BaseUrlApi}/teacher_availability/${currentId}`,
          form
        );
        toast("Success", {
          description: "Availability updated successfully",
        });
      } else {
        await axios.post(`${BaseUrlApi}/teacher_availability`, form);
        toast("Success", {
          description: "Availability added successfully",
        });
      }

      // Refresh availabilities, reset form and close dialog
      fetchAvailabilities();
      resetForm();
      setIsDialogOpen(false);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object") {
        toast("Error", {
          description: result,
        });
      }
      setErrors(result);
    } finally {
      setLoading({ edit: false });
    }
  };

  // Function to open delete confirmation dialog
  const openDeleteDialog = (id, e) => {
    if (e) e.stopPropagation();
    setAvailabilityToDelete(id);
    setDeleteDialogOpen(true);
  };

  // Function to handle deletion of an availability
  const handleDelete = async () => {
    if (!availabilityToDelete) return;

    try {
      setLoading({ delete: true });
      await axios.delete(
        `${BaseUrlApi}/teacher_availability/${availabilityToDelete}`
      );
      toast("Success", {
        description: "Availability deleted successfully",
      });
      fetchAvailabilities();
    } catch (error) {
      const errorMessage = ErrorMessage(error);
      toast("Error", {
        description:
          typeof errorMessage === "string"
            ? errorMessage
            : "Failed to delete availability",
      });
    } finally {
      setLoading({ delete: false });
      setDeleteDialogOpen(false);
      setAvailabilityToDelete(null);
    }
  };

  // Function to open edit dialog
  const handleEdit = (availability) => {
    setIsEditing(true);
    setCurrentId(availability.id);
    console.log(availability);
    setForm({
      day_of_week: availability.day_of_week,
      start_time: dayjs(availability.start_time, "hh:mm").format("HH:MM"),
      end_time: dayjs(availability.end_time, "hh:mm").format("HH:MM"),
      start_date: availability.start_date,
      end_date: availability.end_date,
    });
    setIsDialogOpen(true);
  };

  // Function to reset form
  const resetForm = () => {
    setForm({
      day_of_week: "Monday",
      start_time: "09:00",
      end_time: "11:00",
      start_date: "",
      end_date: "",
    });
    setIsEditing(false);
    setCurrentId(null);
    setErrors({});
  };

  // Function to open add dialog
  const handleAdd = () => {
    resetForm();
    setIsDialogOpen(true);
  };

  // Function to handle time change (using dayjs for formatting)
  const handleTimeChange = (field, value) => {
    if (value) {
      setForm({
        ...form,
        // Use HH:mm format instead of HH:mm:ss
        [field]: value.format("HH:mm"),
      });
    }
  };

  // Function to handle date range change
  const handleDateRangeChange = (dates) => {
    if (dates && dates.length === 2) {
      setForm({
        ...form,
        start_date: dates[0].format("YYYY-MM-DD"),
        end_date: dates[1].format("YYYY-MM-DD"),
      });
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold">Teacher Availability</h2>
        <Button onClick={handleAdd}>
          <Plus className="mr-2 h-4 w-4" />
          Add Availability
        </Button>
      </div>

      <TimeSelectorTeacher
        data={availabilities}
        loading={loading.availabilities}
        handleEdit={handleEdit}
        openDeleteDialog={openDeleteDialog}
      />

      {/* Add/Edit Dialog */}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle>
              {isEditing ? "Edit Availability" : "Add Availability"}
            </DialogTitle>
            <DialogDescription>
              Set the day, time, and date range for teacher availability.
            </DialogDescription>
          </DialogHeader>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="day_of_week" className="text-sm font-medium">
                Day of Week
              </label>
              <Select
                value={form.day_of_week}
                onValueChange={(value) =>
                  setForm({ ...form, day_of_week: value })
                }
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select day" />
                </SelectTrigger>
                <SelectContent>
                  {daysOfWeek.map((day) => (
                    <SelectItem key={day} value={day}>
                      {day}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {errors?.day_of_week && (
                <p className="text-red-500 font-semibold text-sm">
                  {errors.day_of_week[0]}
                </p>
              )}
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label htmlFor="start_time" className="text-sm font-medium">
                  Start Time
                </label>
                <TimePicker
                  className="w-full"
                  format="HH:mm"
                  value={
                    form.start_time ? dayjs(form.start_time, "HH:mm") : null
                  }
                  onChange={(time) => handleTimeChange("start_time", time)}
                  minuteStep={15}
                  showNow={false}
                  allowClear={false}
                />
                {errors?.start_time && (
                  <p className="text-red-500 font-semibold text-sm">
                    {errors.start_time[0]}
                  </p>
                )}
              </div>
              <div className="space-y-2">
                <label htmlFor="end_time" className="text-sm font-medium">
                  End Time
                </label>
                <TimePicker
                  className="w-full"
                  format="HH:mm"
                  value={form.end_time ? dayjs(form.end_time, "HH:mm") : null}
                  onChange={(time) => handleTimeChange("end_time", time)}
                  minuteStep={15}
                  showNow={false}
                  allowClear={false}
                />
                {errors?.end_time && (
                  <p className="text-red-500 font-semibold text-sm">
                    {errors.end_time[0]}
                  </p>
                )}
              </div>
            </div>

            <div className="space-y-2">
              <label htmlFor="date_range" className="text-sm font-medium">
                Date Range
              </label>
              <DatePicker.RangePicker
                className="w-full"
                value={
                  form.start_date && form.end_date
                    ? [dayjs(form.start_date), dayjs(form.end_date)]
                    : null
                }
                onChange={handleDateRangeChange}
                format="YYYY-MM-DD"
                allowClear={false}
              />
              {(errors?.start_date || errors?.end_date) && (
                <p className="text-red-500 font-semibold text-sm">
                  {errors.start_date?.[0] || errors.end_date?.[0]}
                </p>
              )}
            </div>

            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                onClick={() => {
                  resetForm();
                  setIsDialogOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button type="submit" disabled={loading.edit}>
                {loading.edit && (
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                )}
                {isEditing ? "Update" : "Add"}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <AlertDialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete Availability</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to delete this availability? This action
              cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => setAvailabilityToDelete(null)}>
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              disabled={loading.delete}
              onClick={handleDelete}
              className="bg-red-600 hover:bg-red-700"
            >
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
